import { render, staticRenderFns } from "./_dayFee.vue?vue&type=template&id=ddbf1e3a"
import script from "./_dayFee.vue?vue&type=script&lang=js"
export * from "./_dayFee.vue?vue&type=script&lang=js"
import style0 from "./_dayFee.vue?vue&type=style&index=0&id=ddbf1e3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports